/** A dismissed row stays mounted while exiting — including after the animation if the mutation is still pending. */
export const getIsRowVisible = (
  feedbackId: string,
  dismissedIds: ReadonlySet<string>,
  exitingIds: ReadonlySet<string>,
) => !dismissedIds.has(feedbackId) || exitingIds.has(feedbackId);
